import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import SimpleTooltip from '../tooltip/SimpleTooltip';
import { PLACEMENT } from '../../values/Placement';
const NoData = (props) => {
    const { text, className = '', tooltip, tooltipPlacement = PLACEMENT.BOTTOM, tooltipWidth = 'auto' } = props, remainingProps = __rest(props, ["text", "className", "tooltip", "tooltipPlacement", "tooltipWidth"]);
    const noDataClasses = classNames('NoData', className);
    if (tooltip) {
        return (_jsxs("span", Object.assign({}, remainingProps, { className: noDataClasses }, { children: [_jsx("span", Object.assign({ className: 'pointer-events-none user-select-none' }, { children: text })), _jsx(SimpleTooltip, Object.assign({ content: tooltip, placement: tooltipPlacement, width: tooltipWidth }, { children: _jsx("span", { className: 'rioglyph rioglyph-info-sign margin-left-5' }) }))] })));
    }
    return (_jsx("span", Object.assign({}, remainingProps, { className: noDataClasses }, { children: _jsx("span", Object.assign({ className: 'pointer-events-none user-select-none' }, { children: text })) })));
};
export default NoData;
